export default {
  headbar: {
    title: '',
    button: {
      start: { label: '了解详情' },
      login: { label: '登录体验' }
    },
    message: {
      exit: '确认退出系统？'
    }
  },
  footer: {
    static: {
      qrsales: { label: '企业微信' },
      qrpubacc: { label: '公众号' },
      copyright: { label: '©️2023 深圳南中科技有限公司' },
      contact: { label: '联系我们', phone: '(086) 133 0296 1084', mail: 'bruce at uzoombox.com' }
    }
  },
  App: {
    metaInfo: {
      title: 'uzoomBox - 数据资产的私云管家',
      keywords: 'uzoombox,私云管家,企业网盘,无界办公,混合办公',
      description: 'uzoombox轻松实现企业数据资产的私有云管理。'
    }
  },
  Home: {
    metaInfo: {
      title: 'uzoomBox - 数据资产的私云管家 | 主页',
      keywords: 'uzoombox,私云管家,企业网盘,无界办公,混合办公',
      description: 'uzoombox轻松实现企业数据资产的私有云管理。'
    },
    slogan: {
      static: {
        oneword: { label: '数据资产的私云管家' },
        keywords: { label: '融合网盘+文库+邮箱功能，<br/>轻松实现企业数据资产的私有云管理' }
      },
      button: {
        start: { label: '了解详情' },
        contact: { label: '联系我们' }
      }
    },
    scene: {
      static: {
        security: { label: '无界办公<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——空间篇', detail: '公司办公、商务旅行、封控居家，<br/>哪里都是您的办公场所' },
        privacy: { label: '无界办公<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——时间篇', detail: '自动备份、版本回溯、误删还原，<br/>助您穿越时间轻松办公' },
        extension: { label: '无界办公<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——终端篇', detail: 'PC端、Web端、移动端，<br/>统统都是您的操作终端' }
      }
    },
    feature: {
      security: {
        label: '安全',
        system: {
          label: '更安全的云端平台',
          details: '采用安全稳定的Linux系统<br/>入侵封禁、病毒查杀、垃圾文件屏蔽'
        },
        data: {
          label: '更安全的数据管理',
          details: '自动云备份，误编辑可回溯<br/>自动云回收，误删除可还原'
        },
        service: {
          label: '更安全的业务系统',
          details: '采用强口令规则，杜绝密码猜测<br/>针对账号非法试探，自动封禁其来源'
        }
      },
      privacy: {
        label: '隐私',
        system: {
          label: '私有云部署',
          details: '数据资产所有权归企业所有<br/>数据资产使用权归企业所有'
        },
        data: {
          label: '公私文档隔离',
          details: '非本组织成员无法访问企业文档<br/>他人无法访问用户个人文档'
        },
        service: {
          label: '私人保险箱',
          details: '文件加密存储<br/>双重密码访问'
        }
      },
      hosted: {
        label: '自主',
        system: {
          label: '数据空间自主',
          details: '存储空间不受限制<br/>企业根据业务需要弹性扩容'
        },
        data: {
          label: '用户账号自主',
          details: '账号数量不受限制<br/>企业根据业务需要添加账号'
        },
        service: {
          label: '软件功能自主',
          details: '功能模块不受限制<br/>服务期内免费更新版本，体验最新功能'
        }
      },
      extension: {
        label: '扩展',
        system: {
          label: '应用市场',
          details: '文档模板、应用插件<br/>更多生产力工具'
        },
        data: {
          label: '系统集成',
          details: '内部业务对接<br/>第三方系统集成'
        },
        service: {
          label: '定制服务',
          details: '倾听您的声音<br/>满足您的需求'
        }
      }
    },
    starter: {
      label: '选择您的商业方案',
      button: {
        contact: { label: '扫码咨询' }
      },
      paas: {
        1: {
          label: '基础版（代建云）',
          price: { main: '¥39,800/年', space: '增加存储：¥8,000/TB/年' },
          header: {
            key: { label: 'Service' },
            value: { label: '服务项目' }
          },
          row: {
            1: { key: 'Object', value: '适用对象：50人以内企业' },
            2: { key: 'Space', value: '存储空间：1TB，可扩容' },
            3: { key: 'Bandwidth', value: '网络带宽：10Mbps' },
            4: { key: 'Account', value: '用户数量：建议50用户内' },
            5: { key: 'Model', value: '功能模块：无限制' },
            6: { key: 'Support', value: '技术支持：免费' }
          }
        },
        2: {
          label: '旗舰版（代建云）',
          price: { main: '¥169,800/年', space: '增加存储：¥8,000/TB/年' },
          header: {
            key: { label: 'Service' },
            value: { label: '服务项目' }
          },
          row: {
            1: { key: 'Object', value: '适用对象：500人以内企业' },
            2: { key: 'Space', value: '存储存储：10TB，可扩容' },
            3: { key: 'Bandwidth', value: '网络带宽：50Mbps' },
            4: { key: 'Account', value: '用户数量：建议500用户内' },
            5: { key: 'Model', value: '功能模块：无限制' },
            6: { key: 'Support', value: '技术支持：免费' }
          }
        },
        3: {
          label: '企业自有云',
          price: { main: '---', space: '定制方案' },
          header: {
            key: { label: 'Service' },
            value: { label: '服务项目' }
          },
          row: {
            1: { key: 'Object', value: '适用对象：具备自建云的企业' },
            2: { key: 'Space', value: '存储空间：无限制' },
            3: { key: 'Account', value: '用户数量：无限制' },
            4: { key: 'Model', value: '功能模块：无限制' },
            5: { key: 'Update', value: '软件升级：服务期内免费' },
            6: { key: 'Support', value: '技术支持：服务期内免费' }
          }
        }
      }
    }
  },
  Page404: {
    content: '404: 页面不存在。'
  }
}
